var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLinkBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 125,
    viewBox: "0 0 250 125",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.001 0C250.001 16.5685 236.569 30 220.001 30L250.001 30V0ZM0 60C0 43.4315 13.4315 30 30 30L250 30V95H250.001L250.001 125C250.001 108.431 236.569 95 220.001 95L30 95C13.4315 95 0 81.5686 0 65L0 60Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLinkBar);
export default __webpack_public_path__ + "static/media/nav-link-bar.c6771710b2769b02ce13627f8adfa3bc.svg";
export { ForwardRef as ReactComponent };